// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M5.17071 4C5.58254 2.83481 6.69378 2 8 2C9.30622 2 10.4175 2.83481 10.8293 4L22 4V6L10.8293 6C10.4175 7.16519 9.30622 8 8 8C6.69378 8 5.58254 7.16519 5.17071 6L2 6L2 4L5.17071 4ZM13.1707 11C13.5825 9.83481 14.6938 9 16 9C17.3062 9 18.4175 9.83481 18.8293 11H22V13H18.8293C18.4175 14.1652 17.3062 15 16 15C14.6938 15 13.5825 14.1652 13.1707 13L2 13L2 11L13.1707 11ZM5.17071 18C5.58254 16.8348 6.69378 16 8 16C9.30622 16 10.4175 16.8348 10.8293 18L22 18V20L10.8293 20C10.4175 21.1652 9.30622 22 8 22C6.69378 22 5.58254 21.1652 5.17071 20H2V18H5.17071Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-adjustment-filled')
export default class AdjustmentFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'adjustment-filled',
    }
  }
}
